import {doc, onSnapshot} from "firebase/firestore";

// Private user profiles are owner-only. Teammate names come from single-document
// reads of the signed-in UID directory, which is also updated on username changes.
export function subscribeAvailabilityUsernames({db, currentUid, userIds, onName, onError}) {
  if (!currentUid) return () => {};
  let active = true;
  const ids = [...new Set(userIds.filter(id => typeof id === "string" && id.trim()).map(id => id.trim()))];
  const unsubscribers = ids.map(uid => {
    const ownProfile = uid === currentUid;
    return onSnapshot(doc(db, ownProfile ? "users" : "uids", uid), snapshot => {
      if (!active) return;
      const data = snapshot.data() || {};
      onName(uid, ownProfile ? data.username || data.userName || data.displayName || data.name || "" : data.username || "");
    }, error => {
      if (!active) return;
      onName(uid, ""); // Let the page retain its roster/availability name fallback.
      onError?.(error);
    });
  });
  return () => {active = false; unsubscribers.forEach(unsubscribe => unsubscribe());};
}
